export default "__VITE_ASSET__DpImIrgi__"